import { render, staticRenderFns } from "./OrderErrorReview.vue?vue&type=template&id=c9764e80"
import script from "./OrderErrorReview.vue?vue&type=script&lang=js"
export * from "./OrderErrorReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports